<template>
    <section>
        <div class="container">
            <h1 class="display-3 section-title color">Me, Myself & I</h1>
            <div class="row g-5 mt-1">
                <div class="col-lg-5 left-side">
                    <p class="about-text">
                        I'm an,
                        <span class="keyword">AUCian</span> & <span class="keyword">ex-STEMer</span> software developer based
                        in Egypt. I have an enthusiastic passion for computer science. I found it at the age of 13, and I will
                        follow it till I RIP :). I've been working on my own to grow this passion, and I'm currently
                        continuing this work studying <span class="keyword">Computer Engineering</span> @
                        <!-- <span class="DCollege"> -->
                        the American University in Cairo.
                        <!-- </span> -->
                        I love Hip-Hop Music as well as E-Sports. Also, I'm a big Marvel fan, especially <em>Spidey</em>.
                    </p>
                    <svg
                        class="spider-web"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        version="1.1"
                        id="Capa_1"
                        x="0px"
                        y="0px"
                        viewBox="0 0 272 272"
                        style="enable-background: new 0 0 272 272"
                        xml:space="preserve"
                    >
                        <g>
                            <path
                                style="fill: #030104"
                                d="M264.436,178.768c-10.482-3.947-17.772-7.112-21.863-9.525c-7.42-4.112-12.317-12.228-14.678-24.363   c-1.957-10.082-0.646-19.536,3.944-28.311c4.585-8.797,11.706-14.774,21.345-17.922l-0.42-2.164   c7.242-2.297,13.418-4.343,18.525-6.143v-1.22l-32.966,8.884c-1.401,0.488-4.664,0.163-9.792-0.973   c-7.604-1.726-14.428-5.793-20.472-12.204c-6.053-6.392-9.835-13.505-11.356-21.326c-1.925-9.886-0.314-18.62,4.826-26.247   l-1.417-0.683c4.065-6.911,7.544-12.862,10.438-17.862h-2.021c-3.805,5.776-6.93,10.617-9.38,14.523   c-3.319,4.916-5.784,8.708-7.398,11.371c-3.983,4.826-10.589,8.146-19.85,9.948c-17.487,3.402-32.085-1.343-43.763-14.245   c-3.067-3.658-4.889-6.408-5.452-8.228c-2.099-10.206-3.889-18.453-5.361-24.74h-1.463c0.902,6.534,1.734,11.751,2.495,15.653   l-1.546,0.297c1.79,11.404-0.456,21.78-6.756,31.114c-6.302,9.333-15.111,15.111-26.422,17.31   c-10.906,2.121-21.088-0.281-30.545-7.198l-0.062-0.312l-0.797,0.803c-7.545-5.42-13.806-9.875-18.779-13.362h-2.292   c4.957,3.891,9.947,7.775,14.968,11.662c11.092,8.733,17.462,17.328,19.102,25.759c2.198,11.315-0.052,21.996-6.736,32.057   c-6.691,10.056-15.598,16.17-26.713,18.328c-1.64,0.322-3.413,0.551-5.303,0.706l-0.732-0.496c-0.271,0.902-0.49,1.38-0.694,1.421   L0,144.49v2.09c8.981-0.876,16.463-1.691,22.444-2.438l11.292-1.225c8.507,0.897,15.724,4.519,21.65,10.834   c5.92,6.323,9.723,13.81,11.402,22.453c2.362,12.134,0.831,21.824-4.588,29.079c-4.424,4.707-7.899,8.257-10.423,10.665   c-4.755,4.467-9.459,8.915-14.095,13.353h4.258c5.072-4.876,9.358-9.094,12.858-12.656l0.374,0.251   c6.229-5.271,12.75-8.56,19.538-9.882c11.307-2.197,21.841,0.063,31.59,6.825c9.752,6.755,15.726,15.79,17.924,27.103   c0.681,3.498,0.48,10.161-0.591,19.973l-0.437,3.748h1.434c1.078-6.894,1.895-12.637,2.451-17.231   c4.397-14.733,14.934-23.724,31.591-26.964c10.292-2,19.122-1.039,26.503,2.854c5.49,2.977,11.039,8.43,16.629,16.312   c1.772,2.646,3.529,5.279,5.269,7.898h2.151l-1.162-2.068c-5.215-9.235-8.037-14.99-8.478-17.248   c-2.321-11.939-0.446-22.926,5.604-32.962c6.055-10.032,14.945-16.198,26.67-18.478c6.374-1.24,13.658-0.625,21.822,1.84   l0.627-1.729c7,2.561,12.898,4.702,17.693,6.424v-1.613C269.68,180.768,267.156,179.792,264.436,178.768z M237.936,100.965   c-0.82,0.159,0.578,0.21,4.19,0.147c-15.015,10.604-20.704,25.279-17.069,43.984c1.564,8.04,5.081,15.149,10.555,21.334   l-10.396-4.058l-0.118-0.618c-10.831-4.085-17.343-11.788-19.546-23.104C201.632,118.48,212.428,105.924,237.936,100.965z    M89.072,160.652c-2.116-10.896-7.916-18.21-17.4-21.921c15.406-3.201,24.412,1.989,27.05,15.563   c1.521,7.823-0.685,14.549-6.639,20.188l0.428,0.554l-5.385,5.22C89.667,173.565,90.312,167.029,89.072,160.652z M88.28,100.595   c-0.479-2.474-1.283-4.983-2.423-7.533c6.722,4.877,10.597,10.001,11.637,15.356l0,0c1.24,6.368-0.17,12.251-4.261,17.636   c-4.074,5.385-9.296,8.169-15.67,8.338l-0.189,0.673l-6.599,0.648c6.588-3.425,11.514-8.333,14.749-14.728   C88.759,114.595,89.681,107.792,88.28,100.595z M179.965,79.568c1.398,7.202,4.77,13.272,10.111,18.212   c5.338,4.937,11.643,7.979,18.908,9.138l0,0l-17.852,5.393c-4.236,1.246-8.508-0.123-12.792-4.082   c-4.302-3.971-6.868-8.114-7.713-12.452c-0.999-5.133-0.144-10.088,2.555-14.888l-0.062-0.315l6.338-10.2   C179.113,73.005,179.283,76.071,179.965,79.568z M182.629,136.05c0.885,4.545,2.679,8.352,5.419,11.449l-12.427-4.642l0.621-1.717   l-0.309,0.06c-4.143-1.54-6.611-4.372-7.41-8.483c-1.6-8.229,4.588-13.71,18.578-16.43l1.242-0.243   C183.01,121.575,181.111,128.246,182.629,136.05z M116.855,143.719c-0.881-4.525-2.918-7.86-6.111-10.015l10.552-1.736l0.548,1.178   l0.365,0.251c2.717-0.328,4.39,1.172,5.035,4.469c0.318,1.643-0.931,4.013-3.735,7.127c-2.402,1.962-4.69,3.902-6.88,5.82   C117.216,148.354,117.296,145.988,116.855,143.719z M100.525,153.631c-1.562-8.03-5.762-13.725-12.615-17.091l0.926-0.178   c6.588-1.281,12.521-2.005,17.825-2.188c4.764,2.492,7.562,5.896,8.402,10.214c0.758,3.907-0.952,8.299-5.127,13.166   c-3.606,3.486-7.176,7.056-10.732,10.744C100.992,163.252,101.443,158.362,100.525,153.631z M100.276,107.875   c-0.2-1.025-0.765-2.843-1.702-5.435c5.978,4.383,10.455,7.677,13.451,9.871l0.847,2.72c0.677,3.499,0.052,6.829-1.899,9.982   c-1.945,3.155-4.575,5.046-7.864,5.686l-1.599-0.011l-0.011,1.605L88.91,133.46C98.656,127.516,102.433,118.97,100.276,107.875z    M165.992,132.89c0.562,2.881,1.803,5.417,3.723,7.603l-0.312,0.06c-2.951-0.921-5.828-1.951-8.615-3.124   c-3.733-1.624-5.754-3.26-6.072-4.903c-0.562-2.889,0.438-4.889,2.989-6.029c-0.039-0.209-0.099-0.503-0.181-0.933l-0.181-0.919   l10.989-2.785C165.97,125.087,165.192,128.77,165.992,132.89z M142.322,131.414l10.887,4.916c-2.232,0.655-3.855,2.147-4.89,4.474   L142.322,131.414z M147.683,144.138c-2.012-0.466-3.636-0.583-4.876-0.339c-1.844,0.354-3.294,1.178-4.322,2.453   c0.518-6.08,0.773-11.371,0.758-15.843l1.055-1.174l7.263,14.273L147.683,144.138z M151.812,132.442l0.609,1.487   c-4.768-1.427-8.293-2.547-10.592-3.397l-1.287-1.668c3.135-0.393,6.816-1.211,11.055-2.465l1.663,0.318   C151.932,128.683,151.453,130.588,151.812,132.442z M142.588,127.828l4.477-6.623c1.213,1.899,2.229,3.19,2.997,3.882   L142.588,127.828z M151.499,122.572c-1.065-1.075-1.679-2.018-1.839-2.848c-0.28-1.435,0.58-3.628,2.567-6.579   c1.325-1.973,2.761-3.95,4.286-5.96c0.107,2.758,1.358,5.336,3.745,7.754c2.392,2.429,4.923,3.905,7.596,4.452l-13.589,4.246   C153.488,124.012,152.556,123.652,151.499,122.572z M148.821,115.406l-0.739-0.496c-1.239,1.319-2.477,2.083-3.709,2.324   c-3.502,0.682-5.526-0.415-6.088-3.302l-2.036-12.102c5,3.73,10.067,5.104,15.209,4.104c0.205-0.041,0.803-0.272,1.797-0.677   c0.619-0.118,1.129-0.22,1.547-0.299h0.001L148.821,115.406z M139.939,127.38c0.296-0.695,0.081-3.425-0.633-8.199   c1.924,1.122,3.92,1.479,5.97,1.078l0.87-0.484l0,0l0,0l0,0c-1.822,3.771-3.217,6.5-4.18,8.175l-3.149,1.896l-0.431-0.563   l0.613-0.118l-1.289-0.066c-3.32-2.765-5.86-4.839-7.613-6.203c3.167-0.186,5.645-1.736,7.423-4.653   C138.736,122.28,139.539,125.329,139.939,127.38z M136.415,129.03L136.415,129.03l-8.206,0.63c0.956-1.667,1.377-3.359,1.263-5.035   L136.415,129.03z M137.16,129.522l1.106,0.755l-8.687,8.096c-0.352-2.928-1.514-5.05-3.479-6.377l1.113-0.855   C129.975,131.033,133.278,130.492,137.16,129.522z M139,130.773l-2.359,14.219c-1.461-3.123-3.937-4.354-7.45-3.673L139,130.773z    M137.904,150.679c0.344-3.161,1.854-5,4.529-5.522c2.676-0.518,4.893,0.441,6.65,2.86l0.859-0.478l5.066,9.587   c-2.911-1.784-6.215-2.317-9.924-1.596c-3.077,0.599-5.691,1.957-7.848,4.091C137.341,156.83,137.559,153.85,137.904,150.679z    M149.777,143.405c0.145-2.587,1.641-4.155,4.53-4.719c1.073,0,2.058,0.126,2.961,0.378l0.128-0.978l8.056,3.556   c-2.226,0.65-4.302,2.326-6.224,5.055c-1.924,2.727-2.874,5.256-2.848,7.593L149.777,143.405z M165.443,115.221   c-3.35-1.798-5.354-4.457-6.036-7.954c-0.48-2.48,0.319-5.512,2.395-9.115c1.825-2.708,3.632-5.521,5.411-8.421   c-0.019,2.138,0.119,3.926,0.4,5.369c1.96,10.082,7.266,16.526,15.929,19.322l-7.538,2.423l-0.123-0.616   C172.262,117.361,168.783,117.026,165.443,115.221z M158.959,98.378l-1.051-0.43c-0.954,2.741-3.283,4.482-6.987,5.199   c-9.257,1.803-14.831-2.138-16.71-11.803l-1.07-7.155c6.495,7.052,15.101,9.558,25.801,7.478c0.609-0.122,2.301-0.773,5.062-1.946   L158.959,98.378z M133.177,100.833l0.554-0.427l2.581,13.274l-0.922,0.178c0.224,3.371-1.306,5.374-4.596,6.014   c-1.44,0.281-2.883,0.034-4.312-0.763l-0.503,0.737l-11.355-9.001c1.802,0.503,3.837,0.545,6.099,0.104   C126.901,109.751,131.048,106.371,133.177,100.833z M115.71,114.8c4.466,3.177,7.802,5.529,10.024,7.019l1.085,2.347   c0.2,1.033-0.039,2.251-0.727,3.665c-0.686,1.419-1.439,2.198-2.26,2.358l-16.352,1.582c2.723-1.382,4.969-3.791,6.763-7.229   C116.03,121.096,116.512,117.843,115.71,114.8z M126.282,144.454l0.68,0.191c0.7-0.776,1.562-1.271,2.591-1.468   c2.879-0.562,5.133,0.602,6.777,3.493l-2.011,16.07c-0.184-3.155-1.963-5.962-5.314-8.406c-3.358-2.442-6.458-3.286-9.296-2.516   l-0.624,0.118L126.282,144.454z M136.981,161.594c2.484-2.625,5.052-4.198,7.731-4.719c5.354-1.04,10.069,1.258,14.147,6.871   c0.573,0.737,3.379,5.855,8.436,15.327c-5.668-3.812-11.679-5.088-18.056-3.849c-5.967,1.158-10.874,3.926-14.72,8.299   C135.639,173.919,136.464,166.615,136.981,161.594z M158.646,157.691c-0.598-3.074,0.085-6.143,2.06-9.205   c1.972-3.043,4.496-4.873,7.577-5.472c0.659,0.092,1.094,0.103,1.291,0.065c9.029,3.574,15.755,6.34,20.183,8.254   c-6.214,0.988-11.336,3.494-15.362,7.465c-4.028,3.99-6.185,9.111-6.466,15.356C161.662,162.768,158.568,157.291,158.646,157.691z    M168.357,82.458c-2.936,3.564-6.87,5.833-11.812,6.792c-5.552,1.081-10.912,0.147-16.084-2.813   c-5.164-2.938-8.283-7.191-9.36-12.743l-2.166-11.118c8.821,11.317,20.643,15.522,35.454,12.642   c3.912-0.763,7.682-2.232,11.312-4.435C170.971,78.324,168.523,82.222,168.357,82.458z M130.301,84.425l1.676,8.629l-0.61,0.119   c0.943,8.146-2.811,13.038-11.249,14.679c-4.115,0.801-7.243,0.035-9.416-2.331l-1.306,1.532l-7.119-5.329   c3.207,0.011,5.735-0.155,7.587-0.515C120.151,99.207,126.973,93.605,130.301,84.425z M123.555,90.053   c-4.142,4.545-8.978,7.357-14.536,8.438c-4.934,0.958-9.201,0.492-12.758-1.369c-0.448-0.126-3.935-2.649-10.446-7.576   c4.027,0.929,8.296,0.943,12.831,0.062c14.604-2.842,23.697-11.544,27.272-26.116l2.34,12.041   C129.257,80.669,127.685,85.516,123.555,90.053z M94.67,176.228c3.22-3.194,6.169-5.054,8.843-5.573   c5.763-1.12,11.177,0.068,16.229,3.582c5.056,3.498,8.165,8.225,9.324,14.197c0.122,0.616,0.178,1.725,0.173,3.326   c-0.007,1.613,0.037,2.721,0.159,3.344l0.061,0.297l0.876-2.093l-1.618,14.731c-1.395-9.342-5.681-16.301-12.865-20.885   c-7.191-4.58-15.515-5.952-24.986-4.113c-1.644,0.318-2.843,0.77-3.585,1.348C89.725,181.564,92.183,178.848,94.67,176.228z    M130.033,191.77c0.176-1.318,0.121-2.693-0.161-4.143c-1.235-6.361-4.508-11.384-9.809-15.061   c-5.308-3.656-11.259-4.863-17.841-3.586c8.189-8.412,13-13.298,14.45-14.66l2.411-0.783c3.286-0.635,6.347,0,9.175,1.904   c2.828,1.911,4.556,4.498,5.196,7.798c0.323,1.647,0.021,6.407-0.906,14.271C131.62,185.365,130.789,190.132,130.033,191.77z    M134.262,185.496c3.361-4.697,8.219-7.676,14.601-8.917c9.875-1.922,17.34,1.329,22.396,9.741l0.311-0.062l9.826,17.633   c-9.041-9.139-19.415-12.574-31.14-10.292c-7.622,1.479-13.636,5.65-18.073,12.487   C133.166,196.922,133.877,190.061,134.262,185.496z M180.456,195.741l-10.506-17.827c-0.676-5.623,0.677-10.742,4.054-15.352   c3.369-4.611,7.841-7.457,13.399-8.538c4.517-0.881,12.37,1.019,23.526,5.675c-9.225,2.008-16.582,6.168-22.078,12.473   C183.351,178.473,180.553,186.328,180.456,195.741z M195.993,150.432c-5.784-3.354-9.286-8.226-10.526-14.604   c-2.16-11.114,1.763-18.374,11.762-21.83l0.199-0.661l14.512-4.438c-8.148,8.634-11.1,18.717-8.861,30.232   c1.439,7.408,4.886,13.584,10.336,18.493C202.775,153.5,196.977,151.11,195.993,150.432z M194.328,46.343   c-1.461,5.621-1.605,11.525-0.404,17.699c1.801,9.259,6.056,17.128,12.762,23.62c6.713,6.489,14.629,10.769,23.793,12.828l0,0   l-11.609,2.904c-8.226,1.599-15.848-0.012-22.879-4.84c-7.021-4.833-11.328-11.362-12.93-19.585   c-0.52-2.683-0.535-6.26-0.011-10.74c0.519-4.47,1.648-7.2,3.373-8.182l-0.367-0.246L194.328,46.343z M146.156,55.55   c8.68,2.903,17.434,3.494,26.288,1.773c5.559-1.081,10.528-2.901,14.943-5.475l-3.913,6.217l-0.307,0.06   c-3.044,7.425-9.495,12.089-19.374,14.01c-8.032,1.562-15.854,0.307-23.477-3.765c-7.626-4.061-12.217-10.116-13.78-18.138   l-1.858-9.564C130.313,47.692,137.47,52.649,146.156,55.55z M84.17,74.483c9.671-1.878,18.035-6.641,25.082-14.323   c7.043-7.67,10.801-16.362,11.263-26.059l3.483,17.917c1.274,7.643-0.81,14.989-6.276,22.032   c-5.474,7.04-12.107,11.32-19.925,12.841c-8.233,1.598-15.296-0.126-21.181-5.167l-0.563,0.43l-11.546-8.34   C71.441,75.475,78.003,75.685,84.17,74.483z M63.092,118.454c5.034-9.821,6.561-19.79,4.604-29.867   c-0.763-3.908-2.151-7.803-4.189-11.673c4.662,3.135,9.248,6.405,13.76,9.811c4.409,4.05,7.159,8.854,8.241,14.409   c1.557,8.016,0.113,15.408-4.343,22.148c-4.453,6.743-10.583,10.87-18.405,12.391c-2.053,0.4-3.524,0.574-4.379,0.529l-0.137,0.98   l-16.9,2.007C50.818,135.214,58.067,128.302,63.092,118.454z M68.895,175.461c-3.402-17.478-12.713-28.584-27.937-33.314   c10.689-2.08,19.039-3.069,25.046-2.953c4.76,0.363,9.208,2.86,13.316,7.519c4.102,4.638,6.652,9.529,7.656,14.673   c1.639,8.44,0.207,15.862-4.317,22.289c-0.952,1.691-6.266,7.312-15.937,16.881C69.817,192.262,70.534,183.904,68.895,175.461z    M124.96,241.447c0.087-1.73-0.526-4.395-1.865-7.971c-3.41-9.805-9.854-17.461-19.367-22.973   c-9.508-5.528-19.399-7.285-29.69-5.281c-3.908,0.758-7.986,2.303-12.236,4.619c4.761-5.193,9.527-10.29,14.326-15.281   c6.327-5.911,12.053-9.387,17.202-10.387c8.631-1.681,16.206-0.114,22.701,4.708c6.487,4.835,10.544,11.458,12.188,19.9   C128.494,210.223,127.413,221.107,124.96,241.447z M196.249,229.188c-10.84-9.64-23.364-13.081-37.562-10.324   c-14.606,2.843-24.948,11.153-31.022,24.929c1.807-15.93,3.231-27.851,4.252-35.732c4.604-7.09,10.608-11.357,18.021-12.802   c14.392-2.798,26.017,2.636,34.873,16.282l0.863-0.49L196.249,229.188L196.249,229.188z M231.686,174.256   c-11.726,2.275-20.842,8.364-27.344,18.278c-6.511,9.912-8.937,20.794-7.273,32.646l-14.536-25.361   c-0.825-8.596,1.265-16.529,6.264-23.795c4.995-7.273,11.701-11.725,20.136-13.363c3.502-0.682,6.152-0.779,7.963-0.271   c2.668,0.552,7.369,2.243,14.116,5.105c6.744,2.849,11.001,4.961,12.765,6.332C239.42,173.382,235.394,173.534,231.686,174.256z"
                            />
                        </g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                    </svg>
                </div>
                <div class="col-lg-7">
                    <transition name="fade-quote" mode="out-in">
                        <div class="quote-container" v-if="quoteNumber != null" @click="resetAndChangeQuote()">
                            <div class="quote-img">
                                <img :src="quotes[quoteNumber]['quote-img']" />
                            </div>
                            <p class="quote">{{ quotes[quoteNumber]["quote"] }}</p>
                            <p class="quote-cite">{{ quotes[quoteNumber]["quote-cite"] }}</p>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div class="d-none" id="imgs-preloader">
            <div class="d-none" v-for="img in quotes" :key="img">
                <img :src="img['quote-img']" />
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "AboutView",
    props: ["themeColor"],
    data() {
        return {
            quoteNumber: null,
            changeQuote: null,
            lastone: null,
            shownQuotes: [],
            quotes: [
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Swain_0.jpg",
                    quote: '"A calculated risk is no risk at all."',
                    "quote-cite": "- Swain, The Noxian Grand General",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Zed_10.jpg",
                    quote: '"Do not fear the shrouded path."',
                    "quote-cite": "- Zed, The Master of Shadows",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Karma_2.jpg",
                    quote: '"Never become a monster to defeat one."',
                    "quote-cite": "- Karma, The Enlightened One",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Jayce_5.jpg",
                    quote: '"I fight for a brighter tomorrow!"',
                    "quote-cite": "- Jayce, The Defender of Tomorrow",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/MasterYi_52.jpg",
                    quote: '"A true master is an eternal student."',
                    "quote-cite": "- Master YI, The Wuju Bladesman",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Nami_15.jpg",
                    quote: '"The softest water wears down the hardest rock."',
                    "quote-cite": "- Nami, The Tidecaller",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Pantheon_5.jpg",
                    quote: '"I have found my limit a thousand times, and still I press further."',
                    "quote-cite": "- Pantheon, The Unbreakable Spear",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Sett_8.jpg",
                    quote: '"A wise master once said: ‘Be like water.’ Guess I’m kind of a tsunami."',
                    "quote-cite": "- Sett, The Boss",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/MonkeyKing_7.jpg",
                    quote: '"No matter how far it is to the top, it’s still within my grasp!"',
                    "quote-cite": "- Wukong, The Monkey King",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Darius_15.jpg",
                    quote: '"War separates men from kings, predators from prey."',
                    "quote-cite": "- Darius, The Hand of Noxus",
                },
                {
                    "quote-img": "https://ddragon.leagueoflegends.com/cdn/img/champion/splash/Ekko_28.jpg",
                    quote: "\"It' not how much time you have, it's how you use it.\"",
                    "quote-cite": "- Ekko, The Boy Who Shattered Time",
                },
                {
                    "quote-img": "https://i.ibb.co/tqcdpKj/thor.jpg",
                    quote: '"I choose to run towards my problems, and not away from them. Because that\'s what heroes do."',
                    "quote-cite": "- Thor Odinson, God of Thunder",
                },
                {
                    "quote-img": "https://i.ibb.co/Bqw8P9j/thanos.jpg",
                    quote: '"The hardest choices require the strongest wills."',
                    "quote-cite": "- Thanos, The Mad Titan",
                },
                {
                    "quote-img": "https://i.ibb.co/QkxfX4m/ironman.jpg",
                    quote: '"Heroes are made by the paths they choose, not the powers they are graced with."',
                    "quote-cite": "- Tony Stark, Iron Man",
                },
                {
                    "quote-img": "https://i.ibb.co/KDwDLJd/spiderman.jpg",
                    quote: '"With great power comes great responsibility."',
                    "quote-cite": "- Uncle Ben, Spiderman's Uncle",
                },
            ],
        };
    },
    methods: {
        resetAndChangeQuote() {
            this.changeQuoteMethod();
            clearInterval(this.changeQuote);
            this.changeQuote = setInterval(() => {
                this.changeQuoteMethod();
            }, 10000);
        },
        changeQuoteMethod() {
            this.shownQuotes.push(this.quoteNumber);
            this.lastone = this.quoteNumber;
            this.quoteNumber = null;
            setTimeout(() => {
                if (this.shownQuotes.length == this.quotes.length) {
                    this.shownQuotes = [this.lastone];
                }
                do {
                    this.quoteNumber = Math.floor(Math.random() * this.quotes.length);
                } while (this.shownQuotes.includes(this.quoteNumber));
            }, 400);
        },
    },
    mounted() {
        // this.quoteNumber = Math.floor(Math.random() * this.quotes.length);
        this.quoteNumber = this.quotes.length - 1;
        // ThemeColor
        Array.from(document.getElementsByClassName("color")).forEach((element) => {
            element.classList.add(this.themeColor);
        });
        // End ThemeColor
        this.changeQuote = setInterval(() => {
            this.shownQuotes.push(this.quoteNumber);
            this.lastone = this.quoteNumber;
            this.quoteNumber = null;
            setTimeout(() => {
                if (this.shownQuotes.length == this.quotes.length) {
                    this.shownQuotes = [this.lastone];
                }
                do {
                    this.quoteNumber = Math.floor(Math.random() * this.quotes.length);
                } while (this.shownQuotes.includes(this.quoteNumber));
            }, 400);
        }, 10000);
    },
    unmounted() {
        clearInterval(this.changeQuote);
    },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/_variables.scss";
@import url("https://fonts.googleapis.com/css2?family=Bree+Serif&display=swap");

.left-side {
    position: relative;
    z-index: 1;
    height: fit-content;
    .about-text {
        position: relative;
        padding-top: 1.5rem;
        padding-left: 1rem;
        letter-spacing: 0.45px;
        line-height: 1.8;
        font-size: 1.05rem;
        z-index: 1;
        .keyword {
            font-weight: 900;
            font-style: italic;
        }
        .DCollege {
            position: relative;
            &:hover {
                text-decoration: line-through;
            }
            &:hover::after {
                content: "Davidson College";
                height: fit-content;
                width: fit-content;
                min-width: 100%;
                white-space: pre;
                // background-color: red;
                position: absolute;
                bottom: -110%;
                left: 0;
                padding-top: 2px;
                text-align: center;
                color: rgb(214, 214, 214);
                font-weight: 900;
                font-size: 0.85em;
                font-style: italic;
            }
        }
        & ~ .spider-web {
            position: absolute;
            bottom: -35%;
            left: -20%;
            width: 37%;
            z-index: 0;
            path {
                fill: #555 !important;
            }
        }
    }
}

.quote-container {
    margin-top: -2rem;
    position: relative;
    .quote-img {
        position: relative;
        padding: 30px;
        &::after {
            content: "";
            position: absolute;
            display: block;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-collapse: separate;
            box-shadow: inset 0 -15px 40px 80px $main-bg-color;
        }
        img {
            width: 100%;
            display: block;
        }
        // & ~ p {
        //   text-align: center;
        //   margin-top: -5rem;
        //   z-index: 2;
        // }
    }
    .quote {
        text-align: center;
        color: white;
        position: absolute;
        width: 60%;
        bottom: 10px;
        left: 50%;
        transform: translateX(-50%);
        font-style: italic;
        font-family: "Bree Serif", serif;
        letter-spacing: 0.75px;
        font-size: 1.1rem;
    }
    .quote-cite {
        text-align: center;
        color: rgba(255, 255, 255, 0.7);
        position: absolute;
        bottom: -20px;
        right: 40px;
        font-style: italic;
        font-family: "Bree Serif", serif;
        letter-spacing: 0.75px;
        font-size: 0.95rem;
    }
}

@media (max-width: 991.98px) {
    .left-side {
        margin-top: 0.7rem;
        .spider-web {
            bottom: -15% !important;
            left: -12.5% !important;
        }
    }
    .quote-container {
        z-index: 1;
        margin-top: 0;
        width: 100vw;
        position: relative;
        left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
        .quote-img {
            padding: 0;
            &::after {
                display: none;
            }
        }
        .quote {
            // bottom: -10px;
            position: relative;
            padding-top: 2rem;
            width: 90%;
        }
        .quote-cite {
            bottom: -40px;
            // position: relative;
        }
    }
}

.fade-quote-enter-active,
.fade-quote-leave-active {
    transition: all 0.4s ease;
}

.fade-quote-enter-from,
.fade-quote-leave-to {
    opacity: 0;
}

.fade-quote-enter-to,
.fade-quote-leave-from {
    opacity: 1;
}
</style>
